import ClientMap from './ClientMap';

export default ClientMap;



// WEBPACK FOOTER //
// ./src/components/ClientMap/index.js